import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { OverlayPositionX } from '../../../ui/gzSelect/types';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templatePackages = document.createElement('template');

templatePackages.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <header class='page__header'>
      <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'></gz-title>
  </header>

  <div class='wrapper'>
    <div class='packages-content'>
      <div class='packages-grid'>
        <gz-grid-view showGlobalActions>
          <div slot='grid-header-actions-slot' class='header__actions'>
            <gz-button id='create-package-button' class='action-button' type='full' color='primary'>
              <span id='create-package-button-text'></span>
            </gz-button>

            <gz-download-kit-button class='action-button' id='download-package-button'></gz-download-kit-button>

            <gz-button id='send-download-links-button' class='action-button' type='quiet' color='secondary'>
              <span id='send-download-links-button-text'></span>
            </gz-button>

            <gz-button id='delete-package-button' class='action-button' type='outline' color='negative'>
              <span id='delete-package-button-text'></span>
            </gz-button>
          </div>
        </gz-grid-view>
      </div>
    </div>
  </div>
`;
